import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableNotificationDismissalFragment = { readonly __typename?: 'NotificationDismissal', readonly id: string, readonly userId: string, readonly key: string, readonly versionAtDismissal?: string | null, readonly dismissedAt: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncNotificationDismissalPullQueryVariables = Types.Exact<{
  input: Types.PullNotificationDismissalInput;
}>;


export type SyncNotificationDismissalPullQuery = { readonly __typename?: 'Query', readonly pullNotificationDismissal: { readonly __typename?: 'PullNotificationDismissalResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'NotificationDismissal', readonly id: string, readonly userId: string, readonly key: string, readonly versionAtDismissal?: string | null, readonly dismissedAt: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncNotificationDismissalPushMutationVariables = Types.Exact<{
  input: Types.PushNotificationDismissalInput;
}>;


export type SyncNotificationDismissalPushMutation = { readonly __typename?: 'Mutation', readonly pushNotificationDismissal: { readonly __typename?: 'PushNotificationDismissalResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'NotificationDismissal', readonly id: string, readonly userId: string, readonly key: string, readonly versionAtDismissal?: string | null, readonly dismissedAt: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableNotificationDismissalFragmentDoc = gql`
    fragment WholeSyncableNotificationDismissal on NotificationDismissal {
  id
  userId
  key
  versionAtDismissal
  dismissedAt
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncNotificationDismissalPullDocument = gql`
    query SyncNotificationDismissalPull($input: PullNotificationDismissalInput!) {
  pullNotificationDismissal(input: $input) {
    documents {
      ...WholeSyncableNotificationDismissal
    }
  }
}
    ${WholeSyncableNotificationDismissalFragmentDoc}`;

/**
 * __useSyncNotificationDismissalPullQuery__
 *
 * To run a query within a React component, call `useSyncNotificationDismissalPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncNotificationDismissalPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncNotificationDismissalPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncNotificationDismissalPullQuery(baseOptions: Apollo.QueryHookOptions<SyncNotificationDismissalPullQuery, SyncNotificationDismissalPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncNotificationDismissalPullQuery, SyncNotificationDismissalPullQueryVariables>(SyncNotificationDismissalPullDocument, options);
      }
export function useSyncNotificationDismissalPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncNotificationDismissalPullQuery, SyncNotificationDismissalPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncNotificationDismissalPullQuery, SyncNotificationDismissalPullQueryVariables>(SyncNotificationDismissalPullDocument, options);
        }
export type SyncNotificationDismissalPullQueryHookResult = ReturnType<typeof useSyncNotificationDismissalPullQuery>;
export type SyncNotificationDismissalPullLazyQueryHookResult = ReturnType<typeof useSyncNotificationDismissalPullLazyQuery>;
export type SyncNotificationDismissalPullQueryResult = Apollo.QueryResult<SyncNotificationDismissalPullQuery, SyncNotificationDismissalPullQueryVariables>;
export const SyncNotificationDismissalPushDocument = gql`
    mutation SyncNotificationDismissalPush($input: PushNotificationDismissalInput!) {
  pushNotificationDismissal(input: $input) {
    rows {
      ...WholeSyncableNotificationDismissal
    }
  }
}
    ${WholeSyncableNotificationDismissalFragmentDoc}`;
export type SyncNotificationDismissalPushMutationFn = Apollo.MutationFunction<SyncNotificationDismissalPushMutation, SyncNotificationDismissalPushMutationVariables>;

/**
 * __useSyncNotificationDismissalPushMutation__
 *
 * To run a mutation, you first call `useSyncNotificationDismissalPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncNotificationDismissalPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncNotificationDismissalPushMutation, { data, loading, error }] = useSyncNotificationDismissalPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncNotificationDismissalPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncNotificationDismissalPushMutation, SyncNotificationDismissalPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncNotificationDismissalPushMutation, SyncNotificationDismissalPushMutationVariables>(SyncNotificationDismissalPushDocument, options);
      }
export type SyncNotificationDismissalPushMutationHookResult = ReturnType<typeof useSyncNotificationDismissalPushMutation>;
export type SyncNotificationDismissalPushMutationResult = Apollo.MutationResult<SyncNotificationDismissalPushMutation>;
export type SyncNotificationDismissalPushMutationOptions = Apollo.BaseMutationOptions<SyncNotificationDismissalPushMutation, SyncNotificationDismissalPushMutationVariables>;